var map = {
	"./choose-up-11_1 virtual.png": "1d34",
	"./choose-up-12_2 virtual.png": "f4a7",
	"./choose-up-12_3 virtual.png": "0f47",
	"./choose-up-13_4 virtual.png": "300c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a19d";